import { ComponentChildren } from 'preact';

type Props = {
  main: ComponentChildren;
  sidebar?: ComponentChildren;
};

export function TwoColumnSection({ main, sidebar }: Props) {
  return (
    <div class="max-w-5xl mx-auto px-6 py-8">
      <div class="flex flex-col lg:flex-row gap-8">
        <div class="flex-1 lg:flex-[3]">{main}</div>
        {sidebar && (
          <>
            <div class="hidden lg:block w-px bg-gray-200" />
            <div class="lg:flex-[2]">{sidebar}</div>
          </>
        )}
      </div>
    </div>
  );
}
